// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Link} from 'react-router-dom';

// Styles
import './password-reset-success.scss';

function PasswordResetSuccess({ absolutePositioned, className }) {
    return (
        <div
            className={classnames(
          {
                    'password-reset-success ': true,
                    'password-reset-success_absolute': absolutePositioned,
                },
                className,
          )}
        >
            Your password has been successfully reset. Please click <Link to="/">here </Link> to go to the login page
        </div>
    );
}

PasswordResetSuccess.propTypes = {
    absolutePositioned: PropTypes.bool,
    className: PropTypes.string,
};

export default PasswordResetSuccess;
